class Type_TVA_Appliquee {
    constructor(data) {
      this.Id = data.Id;
      this.Name = data.Name;
    }
  }
  
  export default Type_TVA_Appliquee;
  